export const success = type => `${type}_SUCCESS`;
export const failure = type => `${type}_FAILURE`;
export const pending = type => `${type}_PENDING`;
